import { render, staticRenderFns } from "./ButtonWithConfirmation.vue?vue&type=template&id=376b5954&scoped=true&"
import script from "./ButtonWithConfirmation.vue?vue&type=script&lang=js&"
export * from "./ButtonWithConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376b5954",
  null
  
)

export default component.exports